import { render } from "./CardContingecyHistory.vue?vue&type=template&id=37bd7682&scoped=true"
import script from "./CardContingecyHistory.vue?vue&type=script&lang=js"
export * from "./CardContingecyHistory.vue?vue&type=script&lang=js"

import "./CardContingecyHistory.vue?vue&type=style&index=0&id=37bd7682&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37bd7682"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection});
